import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";

import { NavLink } from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';
import { NotificationsContext } from '../context/NotificationsContext';

import { HeaderCheckbox } from './UI';

import { ReactComponent as NotificationSvg } from '../assets/notification.svg';

import db from "../firebase";
import { doc, getDocs, collection, query, where, updateDoc, arrayUnion, addDoc, Timestamp, setDoc, onSnapshot } from "firebase/firestore";
import { dateFormatNotifications } from "../utils/functions";

export default function Notifications() {

	const { currentUser } = useContext(AuthContext);
	const { notifications } = useContext(NotificationsContext);

	//=================================================================
	// add test notifications ( TODO => remove )

	const addTestNotificaitons = async () => {

		const testNotifications = [
			'Welcome! You can watch a video of new features!',
			'Discounts on premium until December 1st',
			'Gifts for all new users!',
			'Activate premium and get new opportunities',
		];

		for (let key in testNotifications){
			let notification = testNotifications[key];
			const now = Timestamp.now();
			const notificationsRef = doc(db, "notifications", currentUser);
			await setDoc(notificationsRef, {
				notifications: arrayUnion(
					{
						timestamp: now,
						text: notification,
					}
				),
			}, { merge: true });
		}
		//getNotifications();
	}

	//==================================================================
    // show and hide notification list

    const [showNotificaitons, setShowNotifications] = useState(false);

	const toggleNotificaitons = async () => {
		if (newNotifications){
			setShowNotifications(!showNotificaitons);
		}
	}

    // click outside => hide dropdown

 	useEffect(() => {
 		const page = document.querySelector('.page');
 		page.addEventListener("click", function(event){
 			var container =  document.querySelector('.notifications');
 			if (!(container.contains(event.target) && event.target !== container))
 				setShowNotifications(false);
 		});
 	});

	//==================================================================
	// user hides one notification

	const [isChecked, setIsChecked] = useState(false);
	const hideNotification = async (i) => {

		//console.log('hide');
		//console.log(i);

		//mark as read

		let data = [...notifications];
		data[i]['hidden'] = true;

		const notificationsRef = doc(db, "notifications", currentUser);
		await updateDoc(notificationsRef, {
			notifications: data,
		});

		getNewNotifications(data);
	}

	//==================================================================
	// check unread notifications

	const [ newNotifications, setNewNotifications ] = useState(false);
	const getNewNotifications = (notifications) => {
		if (notifications == 'not found')
			return;
		var newNotifications = [];
		for(let key in notifications){
			let notification = notifications[key];
			if (!notification['hidden']){
				notification['index'] = key;
				newNotifications.push(notification);
			}
		}
		//console.log(newNotifications);

		setNewNotifications(newNotifications);
	}
	useEffect(() => {

		getNewNotifications(notifications);

	},[notifications]);


	return (

		<div className="notifications">
			{/* <div onClick={addTestNotificaitons} className="add-test-notifications">
				ADD TEST DATA
			</div> */}

			<div className={"notifications-icon" + (newNotifications && newNotifications.length > 0 ? " active" : "")} onClick={toggleNotificaitons}>
				{(!newNotifications || newNotifications.length == 0) ?
					<NavLink to="/notifications" className="show-all">
						<NotificationSvg />
					</NavLink>
					:
					<NotificationSvg />
				}
			</div>

			{newNotifications && showNotificaitons && newNotifications.length > 0 &&
				<div className="notifications-bg">
					<div className="notifications-list">
						{
							newNotifications.map((notification, notificationIndex) =>
								 notification.text && !notification.hidden && notificationIndex < 5 &&
									<div className="notification" key={notificationIndex}>
										<div className="date">
											{notification.timestamp && dateFormatNotifications(notification.timestamp.seconds)}
										</div>
										<div>
											{notification.text}
										</div>
										<label>
											<input type="checkbox" onClick={() => { setIsChecked(!isChecked); }} title="hide" onClick={() => hideNotification(notification['index'])}/>
											<span className={`checkbox ${isChecked ? "checkbox--active" : ""}`} aria-hidden="true"></span>
										</label>
									</div>
							)
						}
					</div>
					<NavLink to="/notifications" className="show-all">Show all</NavLink>
				</div>
			}

		</div>
	)
}
